import React from "react";

const RadioCardGroup = ({
  label,
  required = false,
  options = [],
  value,
  onChange,
  name = "radio-group",
}) => {
  return (
    <div>
      {/* Label */}
      <label className="block text-sm md:font-semibold font-medium text-gray-700 mb-1">
        {label}
        {required && <span className="text-red-500 ml-1 font-bold">*</span>}
      </label>

      {/* Radio Cards */}
      <div className="flex md:flex-row flex-col gap-3">
        {options.map((option) => (
          <label key={option?.value} className="flex-1 relative cursor-pointer">
            <input
              type="radio"
              onClick={() => onChange(option?.value)}
              className="peer sr-only"
              checked={value == option?.value}
            />
            <div className="md:px-4 px-2 py-3 md:text-md text-sm border-2 border-gray-300 rounded-lg text-center peer-checked:border-[#2bace2] peer-checked:bg-[#2bace2]/5 peer-checked:text-[#2bace2] transition-all font-medium">
              {option?.label}
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioCardGroup;
